export type State = "ACT" | "NSW" | "NT" | "QLD" | "SA" | "VIC" | "WA" | "TAS";
export interface UnitType {
  label: string;
  value: string;
}

export const unitTypeOptions = [
  { label: "Unit", value: "U" },
  { label: "Apartment", value: "APT" },
  { label: "Shop", value: "SHOP" },
  { label: "Factory", value: "FY" },
  { label: "Flat", value: "F" },
  { label: "Site", value: "SITE" },
  { label: "Stall", value: "SL" },
  { label: "Marine Berth", value: "MB" },
  { label: "Suite", value: "SE" },
  { label: "Studio", value: "STU" },
  { label: "Office", value: "OFF" },
  { label: "Room", value: "RM" },
  { label: "Shed", value: "SHED" },
  { label: "Ward", value: "WARD" },
  { label: "Warehouse", value: "WE" },
  { label: "Townhouse", value: "TNHS" },
  { label: "Kiosk", value: "KSKU" },
  { label: "Lot", value: "LOT" },
];

export const stateOptions: State[] = [
  "ACT",
  "NSW",
  "NT",
  "QLD",
  "SA",
  "VIC",
  "WA",
  "TAS",
];
